import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import moment from "moment/moment";

const DetailInfoModal = ({ isOpen, onClose, detailData }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} style={{ paddingTop: "40px" }}>
      <ModalHeader toggle={onClose} style={{ paddingTop: "20px" }}>Detail Data</ModalHeader>
      <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
        {detailData ? (
          <div>
            <p><strong>Status Rumah:</strong> {detailData.statusrumah}</p>
            <p><strong>Nomor Blok:</strong> {detailData?.nomorUrut || '-'}</p>
            <p><strong>Nomor Rumah Pada Peta:</strong> {detailData.nomorRumahPadaPeta}</p>
            <p><strong>Nama Lengkap KK:</strong> {detailData.namaLengkapKK}</p>
            <p><strong>Usia:</strong> {detailData.usia} Tahun</p>
            <p><strong>Tanggal Lahir:</strong> {detailData.tanggallahir ? moment(detailData.tanggallahir).format('DD/MM/YYYY') : 'Tidak tersedia'}</p>
            <p><strong>Jenis Kelamin:</strong> {detailData.jenisKelamin}</p>
            <p><strong>Nomor KK:</strong> {detailData.nomorKK}</p>
            <p><strong>Nomor KTP:</strong> {detailData.nomorKTP}</p>
            <p><strong>Asal KTP:</strong> {detailData.asalKTP}</p>
            <p><strong>Jumlah KK:</strong> {detailData.jumlahKK}</p>
            <p><strong>Jumlah Penghuni:</strong> {detailData.jumlahPenghuni}</p>
            <p><strong>Alamat Rumah:</strong> {detailData.alamatRumah}</p>
            <p><strong>Kecamatan:</strong> {detailData.kecamatan}</p>
            <p><strong>Desa/Kelurahan:</strong> {detailData.desaKelurahan}</p>
            <p><strong>Pendidikan Terakhir:</strong> {detailData.pendidikanTerakhir}</p>
            <p><strong>Pekerjaan:</strong> {detailData.pekerjaan}</p>
            <p><strong>Fungsi Bangunan:</strong> {detailData.fungsiBangunan}</p>
            <p><strong>Penghasilan:</strong> {detailData.penghasilan}</p>
            <p><strong>Status Kepemilikan Rumah:</strong> {detailData.statusKepemilikanRumah}</p>
            <p><strong>Aset Rumah di Tempat Lain:</strong> {detailData.asetRumahDiTempatLain}</p>
            <p><strong>Status Kepemilikan Tanah:</strong> {detailData.statusKepemilikanTanah}</p>
            <p><strong>Aset Tanah di Tempat Lain:</strong> {detailData.asetTanahDiTempatLain}</p>
            <p><strong>Sumber Penerangan:</strong> {detailData.sumberPenerangan}</p>
            <p><strong>Daya Listrik:</strong> {detailData.dayaListrik}</p>
            <p><strong>Bantuan Perumahan:</strong> {detailData.bantuanPerumahan}</p>
            <p><strong>Jenis Rumah:</strong> {detailData.modelRumah}</p>
            <p><strong>Pondasi:</strong> {detailData.pondasi}</p>
            <p><strong>Kolom:</strong> {detailData.kolom}</p>
            <p><strong>Rangka Atap:</strong> {detailData.rangkaAtap}</p>
            <p><strong>Plafon:</strong> {detailData.plafon}</p>
            <p><strong>Balok:</strong> {detailData.balok}</p>
            <p><strong>Sloof:</strong> {detailData.sloof}</p>
            <p><strong>Pintu/Jendela/Konsen:</strong> {detailData.pintuJendelaKonsen}</p>
            <p><strong>Ventilasi:</strong> {detailData.ventilasi}</p>
            <p><strong>Material Lantai Terluas:</strong> {detailData.materialLantaiTerluas}</p>
            <p><strong>Kondisi Lantai:</strong> {detailData.kondisiLantai}</p>
            <p><strong>Material Dinding Terluas:</strong> {detailData.materialDindingTerluas}</p>
            <p><strong>Kondisi Dinding:</strong> {detailData.kondisiDinding}</p>
            <p><strong>Material Penutup Atap Terluas:</strong> {detailData.materialPenutupAtapTerluas}</p>
            <p><strong>Kondisi Penutup Atap:</strong> {detailData.kondisiPenutupAtap}</p>
            <p><strong>Luas Rumah:</strong> {detailData.luasRumah}</p>
            <p><strong>Luas Tanah:</strong> {detailData.luasTanah}</p>
            <p><strong>Buangan Air Limbah Rumah Tangga:</strong> {detailData.buanganAirLimbahRumahTangga}</p>
            <p><strong>Sarana Pengelolaan Limbah Cair:</strong> {detailData.saranaPengelolaanLimbahCair}</p>
            <p><strong>Pemeliharaan Sarana Pengelolaan Limbah:</strong> {detailData.pemiliharaanSaranaPengelolaanLimbah}</p>
            <p><strong>Jenis Tempat Pembuangan Air Tinja:</strong> {detailData.jenisTempatPembuanganAirTinja}</p>
            <p><strong>Kepemilikan Kamar Mandi dan Jamban:</strong> {detailData.kepemilikanKamarMandiDanJamban}</p>
            <p><strong>Jumlah Jamban:</strong> {detailData.jumlahJamban}</p>
            <p><strong>Jenis Kloset:</strong> {detailData.jenisKloset}</p>
            <p><strong>Jenis Tangki Septik:</strong> {detailData.jenisTangkiSeptik}</p>
            <p><strong>Material Tangki Septik:</strong> {detailData.materialTangkiSeptik}</p>
            <p><strong>Alas Tangki Septik:</strong> {detailData.alasTangkiSeptik}</p>
            <p><strong>Lubang Penyedotan:</strong> {detailData.lubangPenyedotan}</p>
            <p><strong>Posisi Tangki Septik:</strong> {detailData.posisiTangkiSeptik}</p>
            <p><strong>Jarak Tangki Septik dengan Sumber Air:</strong> {detailData.jarakTangkiSeptikDenganSumberAir}</p>
            <p><strong>Sumber Air Minum:</strong> {detailData.sumberAirMinum}</p>
            <p><strong>Titik Koordinat Rumah:</strong> {detailData.titikKoordinatRumah}</p>
            <p><strong>Manual Titik Koordinat Rumah:</strong> {detailData.manualTitikKoordinatRumah}</p>
            <p><strong>Tanggal Pendataan:</strong> {detailData.tanggalPendataan}</p>
            <p><strong>Nama Surveyor:</strong> {detailData.Admin?.username || "Data tidak tersedia"}</p>
            <p><strong>Skor:</strong> {detailData.score}</p>
            <p><strong>Kategori:</strong> {detailData.kategori}</p>
            <p><strong>Catatan:</strong> {detailData.catatan || "Tidak ada catatan"}</p>
            <p><strong>Status Validasi Bantuan:</strong> {detailData.verifikasiBantuan || "Tidak ada status verifikasi bantuan"}</p>

            <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid #ddd' }}>
              <h6 style={{ fontWeight: 700, marginBottom: 10 }}>Data Bantuan</h6>
              {detailData._loadingBantuan ? (
                <p>Memuat data bantuan...</p>
              ) : (() => {
                const b = detailData.bantuan || (Array.isArray(detailData.Bantuans) ? detailData.Bantuans[0] : null);
                if (!b) {
                  return <p style={{ color: '#888' }}><em>Belum ada data bantuan terhubung.</em></p>;
                }
                const fmt = (n) => n == null ? '-' : new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(n);
                return (
                  <>
                    <p><strong>ID Bantuan:</strong> #{b.id}</p>
                    <p><strong>Jenis / Kategori Bantuan:</strong> {b.JenisBantuan || '-'}</p>
                    <p><strong>Anggaran / Nominal:</strong> {fmt(b.nominal)}</p>
                    <p><strong>Tanggal Mulai Bantuan:</strong> {b.tanggalBantuan ? moment(b.tanggalBantuan).format('DD/MM/YYYY') : '-'}</p>
                    <p><strong>Tanggal Selesai:</strong> {b.tanggalSelesai ? moment(b.tanggalSelesai).format('DD/MM/YYYY') : '-'}</p>
                    <p><strong>Status Proses:</strong> {b.ProsesBantuan?.statusProses || '-'}</p>
                    <p><strong>Progress:</strong> {b.Presentase?.presentase != null ? `${b.Presentase.presentase}%` : '-'}</p>
                    <p><strong>Status Kontrak:</strong> {b.statusKontrak || '-'}</p>
                  </>
                );
              })()}
            </div>
          </div>
        ) : (
          <p>Data tidak tersedia</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>Tutup</Button>
      </ModalFooter>
    </Modal>
  );
};

export default DetailInfoModal;


